<template>
  <span class="sIcon" aria-hidden="true">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.13007 10.2238L6.60468 11.4272C6.40294 11.8898 5.76273 11.8898 5.56051 11.4272L5.03512 10.2238C4.56737 9.15274 3.7259 8.3004 2.67606 7.83454L1.23029 7.19292C0.770569 6.98881 0.770569 6.31979 1.23029 6.11568L2.63117 5.4939C3.70794 5.01576 4.56454 4.13176 5.02426 3.02475L5.55626 1.74246C5.75376 1.26667 6.41144 1.26667 6.60893 1.74246L7.14094 3.02475C7.60066 4.13223 8.45725 5.01623 9.53402 5.4939L10.9349 6.11568C11.3946 6.31979 11.3946 6.98881 10.9349 7.19292L9.48866 7.83501C8.4393 8.30087 7.59735 9.15322 7.13007 10.2238Z"
        fill="currentColor"
      />
      <path
        d="M11.9795 14.0457L11.8194 14.4128C11.7022 14.6816 11.3299 14.6816 11.2127 14.4128L11.0526 14.0457C10.7672 13.3913 10.2527 12.8702 9.61104 12.5848L9.11777 12.3656C8.85082 12.247 8.85082 11.8591 9.11777 11.7405L9.58363 11.5335C10.2418 11.2411 10.7653 10.7006 11.0459 10.024L11.2104 9.6271C11.3252 9.35071 11.7074 9.35071 11.8217 9.6271L11.9862 10.024C12.2668 10.7006 12.7903 11.2411 13.4485 11.5335L13.9143 11.7405C14.1813 11.8591 14.1813 12.247 13.9143 12.3656L13.4211 12.5848C12.7794 12.8702 12.2649 13.3913 11.9795 14.0457Z"
        fill="currentColor"
      />
    </svg>
  </span>
</template>

<style scoped>
svg {
  display: block;
  width: 16px;
  height: 16px;
}
</style>
